import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import { articles } from "@/mocks/articles";

export default function TopicsSection() {
  const countOf = (id: string) => articles.filter((article) => article.category === id).length;

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <span className="flex items-center gap-2 font-label text-xs tracking-[0.2em] text-secondary-600">
            <i className="ri-price-tag-3-line" aria-hidden="true"></i>
            TOPICS
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            从五个方向拆解赛果
          </h2>
          <p className="mt-4 text-sm leading-loose text-foreground-700">
            一场比赛的争议通常不会只有一个来源。我们把线索归到五个方向，每条线索都能回到具体的规则条文与公开物料。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {topics.map((topic) => (
            <Link
              key={topic.id}
              to={`/topics?topic=${topic.id}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors duration-200 hover:border-primary-300"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${topic.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600">
                {topic.name}
              </h3>
              <p className="mt-1 font-label text-xs text-accent-700">{topic.tagline}</p>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {topic.description}
              </p>
              <span className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                <span>{countOf(topic.id)} 篇深度解析</span>
                <i className="ri-arrow-right-up-line text-base text-primary-600 transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
              </span>
            </Link>
          ))}

          <div className="flex flex-col justify-between rounded-lg border border-dashed border-secondary-300 bg-secondary-100 p-6">
            <div>
              <h3 className="font-heading text-lg font-bold text-secondary-900">手上有物料？</h3>
              <p className="mt-3 text-sm leading-relaxed text-secondary-900">
                公示照片、通稿截图、赛程文件、票数变化记录，都是我们最需要的可核查线索。
              </p>
            </div>
            <Link
              to="/about#contact"
              className="mt-5 flex items-center justify-center gap-2 rounded-md bg-secondary-500 px-4 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-secondary-600 whitespace-nowrap"
            >
              <i className="ri-mail-send-line" aria-hidden="true"></i>
              去投递线索
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}